import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBriefcase, FiBookOpen } = FiIcons;

const WorkEducationSection = ({ workHistory, education }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="grid md:grid-cols-2 gap-8"
    >
      {/* Work History */}
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20">
        <div className="flex items-center space-x-3 mb-6">
          <SafeIcon icon={FiBriefcase} className="text-2xl text-purple-400" />
          <h3 className="text-2xl font-bold text-white">🏢 WORK HISTORY</h3>
        </div>
        <div className="space-y-4">
          {workHistory.map((job, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-black/30 rounded-lg p-4 border border-purple-500/20"
            >
              <h4 className="text-lg font-semibold text-white">{job.role}</h4>
              <p className="text-purple-300">{job.company}</p>
              <p className="text-sm text-purple-400">{job.years}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Education */}
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20">
        <div className="flex items-center space-x-3 mb-6">
          <SafeIcon icon={FiBookOpen} className="text-2xl text-purple-400" />
          <h3 className="text-2xl font-bold text-white">📚 EDUCATION</h3>
        </div>
        <div className="space-y-4">
          {education.map((edu, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-black/30 rounded-lg p-4 border border-purple-500/20"
            >
              <h4 className="text-lg font-semibold text-white">{edu.degree}</h4>
              <p className="text-purple-300">{edu.institution}</p>
              <p className="text-sm text-purple-400">{edu.year}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default WorkEducationSection;